import React, { useState, useEffect } from 'react';
import { get } from '../utils/api';

const fmt = d => d ? new Date(d).toLocaleDateString('en-NG',{day:'numeric',month:'short',year:'numeric'}) : '—';

export default function PayrollEnrolments() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    get('/biodata/payroll/submissions')
      .then(d => setRecords(d.data||[]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="flex-between mb-lg">
        <div>
          <h2 className="page-title">Payroll Enrolments</h2>
          <p className="text-muted text-sm">Bank details submitted by staff for payroll setup</p>
        </div>
        <div style={{fontSize:13,color:'#8A8A8A'}}>{records.length} submission{records.length!==1?'s':''}</div>
      </div>

      {loading ? <div className="spinner"/> : records.length === 0 ? (
        <div className="empty-state">
          <h3>No submissions yet</h3>
          <p>Bank details will appear here once staff complete their payroll enrolment form</p>
        </div>
      ) : (
        <div style={{display:'flex',gap:16}}>
          {/* List */}
          <div style={{width:320,flexShrink:0}}>
            {records.map(r => (
              <div key={r.id} onClick={()=>setSelected(r)}
                style={{background:selected?.id===r.id?'#F2EFE7':'#fff',
                  border:'1px solid '+(selected?.id===r.id?'#556B2F':'#E8E0D4'),
                  borderRadius:10,padding:14,marginBottom:10,cursor:'pointer'}}>
                <div style={{fontWeight:700,fontSize:13,color:'#3B2A21',marginBottom:4}}>{r.full_name}</div>
                <div style={{fontSize:11,color:'#8A8A8A',marginBottom:4}}>{r.email}</div>
                <div style={{fontSize:12,color:'#556B2F',fontWeight:600}}>{r.bank_name}</div>
                <div style={{fontSize:11,color:'#8A8A8A',marginTop:4}}>Submitted: {fmt(r.submitted_at)}</div>
                <span style={{fontSize:9,fontWeight:700,padding:'2px 8px',borderRadius:20,
                  background:r.review_status==='approved'?'#E8F5EB':r.review_status==='flagged'?'#FDEAEA':'#FFF3DC',
                  color:r.review_status==='approved'?'#2E6B3A':r.review_status==='flagged'?'#8F2E24':'#8B5E0A'}}>
                  {r.review_status==='approved'?'✅ Approved':r.review_status==='flagged'?'⚠ Flagged':'⏳ Pending Review'}
                </span>
              </div>
            ))}
          </div>

          {/* Detail */}
          {selected && (
            <div style={{flex:1,background:'#fff',border:'1px solid #E8E0D4',borderRadius:12,padding:24}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:20}}>
                <div>
                  <h3 style={{fontFamily:'Georgia,serif',color:'#3B2A21',marginBottom:4}}>{selected.full_name}</h3>
                  <div style={{fontSize:12,color:'#8A8A8A'}}>Submitted {fmt(selected.submitted_at)}</div>
                </div>
                <button className="btn btn-ghost btn-sm" onClick={()=>setSelected(null)}>✕</button>
              </div>

              {[
                ['Bank Name', selected.bank_name],
                ['Account Name', selected.account_name],
                ['Account Number', selected.account_number],
                ['Account Type', selected.account_type],
                ['Bank Code', selected.bank_code],
                ['Name Difference Explanation', selected.name_difference_explanation],
              ].filter(([,v])=>v).map(([label,value])=>(
                <div key={label} style={{display:'flex',borderBottom:'1px solid #F2EFE7',padding:'10px 0'}}>
                  <div style={{width:'40%',fontSize:11,color:'#8A8A8A',fontWeight:600,textTransform:'uppercase',letterSpacing:'.04em'}}>{label}</div>
                  <div style={{width:'60%',fontSize:13,fontWeight:600,color:'#2C1F16'}}>{value}</div>
                </div>
              ))}

              <div style={{marginTop:20,display:'flex',gap:8}}>
                {selected.review_status !== 'approved' && (
                  <button className="btn btn-primary" onClick={async()=>{
                    await fetch('/api/biodata/payroll/review/'+selected.id, {
                      method:'POST',
                      headers:{'Content-Type':'application/json','Authorization':'Bearer '+localStorage.getItem('bb_token')},
                      body: JSON.stringify({decision:'approved'})
                    });
                    setRecords(records.map(r=>r.id===selected.id?{...r,review_status:'approved'}:r));
                    setSelected({...selected,review_status:'approved'});
                  }}>✓ Approve</button>
                )}
                {selected.review_status !== 'flagged' && (
                  <button className="btn btn-outline" style={{color:'#8F2E24',borderColor:'#8F2E24'}} onClick={async()=>{
                    const note = window.prompt('What issue did you find?');
                    if (!note) return;
                    await fetch('/api/biodata/payroll/review/'+selected.id, {
                      method:'POST',
                      headers:{'Content-Type':'application/json','Authorization':'Bearer '+localStorage.getItem('bb_token')},
                      body: JSON.stringify({decision:'flagged', note})
                    });
                    setRecords(records.map(r=>r.id===selected.id?{...r,review_status:'flagged'}:r));
                    setSelected({...selected,review_status:'flagged'});
                  }}>⚠ Flag Issue</button>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
